@if (notifications.length) {
<article>

    <section>

        @for (notification of notifications; track notification) {
  

            <div class="item">
                <span class="item__title">{{ notification.title }}</span>
                <span class="item__date">{{ getTime(notification.date) | async }}</span>
                <span>{{ notification.message }}</span>
                <span class="item__button"><button mat-icon-button (click)="readNotification(notification)"><mat-icon>done</mat-icon></button></span>
                
                
                
            </div>
            <mat-divider></mat-divider>
        
}


    </section>
    <section class="as-read">
        <button mat-button (click)="markAll()">Mark all as read</button>
    </section>
</article>
}
@if (!notifications.length) {
<article>
    <span class="as-read">

        All Caught up!
    </span>
</article>
}